import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import globalCourseStore from '../../../../../stores/global-course-store';
import { ApiErrorCodes } from '../../../../../api/errors/api-error-codes';

export const lecturesDeleteOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  lectureId: number | undefined,
  setLoading: (lectureId: number | null) => any,
) => {
  try {
    if (!programId || !courseId || !lectureId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setLoading(lectureId);
    const deleteRes = await appApi.deleteLecture(
      programId,
      courseId,
      lectureId,
    );

    if (deleteRes.data.errCode === ApiErrorCodes.LECTURES_HAS_USAGE) {
      toast.warn('לא ניתן למחוק הרצאה שרצה');
      setLoading(null);
      return;
    }

    if (deleteRes.status === HttpStatusCode.Ok) {
      globalCourseStore.updateCourseDetails(
        courseId,
        deleteRes.data.body.metadata,
        deleteRes.data.body.details,
      );
    }
    setLoading(null);
  } catch (e) {
    setLoading(null);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `lecturesDeleteOperation is failed with the programId: ${programId}, courseId: ${courseId}, lectureId: ${lectureId} with the error: ${e}`,
    );
  }
};
